import { TableDescriptions } from '../../../@types/interfaces/table-interface';

export const ColumsTableSyntheticAdapter: TableDescriptions[] = [
  { text: '', dataField: 'checkbox', hidden: false, align: 'center', order: 0, id: -1, fixed: true },
  { ordination: { ordinationName: 'ID', ordinationValue: '' }, align: 'center', order: 1, id: 0, dataField: 'id', text: 'ID', hidden: false, fixed: true },
  {
    ordination: { ordinationName: 'BASE', ordinationValue: '' },
    align: 'center',
    order: 2,
    id: 2,
    dataField: 'base',
    columnName: 'base',
    text: 'Base',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'ID_FABRICANTE', ordinationValue: '' },
    align: 'center',
    order: 3,
    id: 1,
    dataField: 'idFabricante',
    columnName: 'idFabricante',
    text: 'Cód. Fab.',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'CODIGO', ordinationValue: '' },
    align: 'center',
    order: 4,
    id: 3,
    dataField: 'codigo',
    columnName: 'codigo',
    text: 'Sufixo',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'NOME', ordinationValue: '' },
    align: 'left',
    order: 5,
    id: 4,
    dataField: 'nome',
    columnName: 'nome',
    text: 'Descrição',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'ALERTA', ordinationValue: '' },
    align: 'left',
    order: 6,
    id: 5,
    dataField: 'ALERTA',
    text: 'ALERTA',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'QUANTIDADE', ordinationValue: '' },
    align: 'center',
    order: 7,
    id: 6,
    dataField: 'quantidade',
    columnName: 'quantidade',
    text: 'Qtd',
    hidden: false,
    fixed: true,
  },
  { align: 'right', order: 8, id: 7, dataField: 'qme', columnName: 'qme', text: 'Qme', hidden: false },
  {
    ordination: { ordinationName: 'MEDIA', ordinationValue: '' },
    align: 'right',
    order: 9,
    id: 8,
    dataField: 'media',
    columnName: 'media',
    text: 'Média',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'PROJECAO_MES', ordinationValue: '' },
    align: 'right',
    order: 10,
    id: 9,
    dataField: 'projecaoMes',
    columnName: 'projecaoMes',
    text: 'PMês',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'ESTOQUE', ordinationValue: '' },
    align: 'right',
    order: 11,
    id: 10,
    dataField: 'estoque',
    columnName: 'estoque',
    text: 'Est',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'PENDENTE', ordinationValue: '' },
    align: 'right',
    order: 12,
    id: 11,
    dataField: 'pendente',
    columnName: 'pendente',
    text: 'Pen',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'EXCESSO', ordinationValue: '' },
    align: 'right',
    order: 13,
    id: 14,
    dataField: 'excesso',
    columnName: 'excesso',
    text: 'Exc',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'PONTUACAO', ordinationValue: '' },
    align: 'right',
    order: 14,
    id: 15,
    dataField: 'pontuacao',
    columnName: 'pontuacao',
    text: 'Ppt',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'CURVA', ordinationValue: '' },
    align: 'left',
    order: 15,
    id: 16,
    dataField: 'curva',
    columnName: 'curva',
    text: 'Cvf',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'NOVA_CURVA', ordinationValue: '' },
    align: 'left',
    order: 16,
    id: 17,
    dataField: 'novaCurva',
    columnName: 'novaCurva',
    text: 'NCvf',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'STATUS', ordinationValue: '' },
    align: 'left',
    order: 17,
    id: 18,
    dataField: 'status',
    columnName: 'status',
    text: 'Status',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'VALOR_PEDIDO', ordinationValue: '' },
    align: 'right',
    order: 18,
    id: 19,
    dataField: 'valorPedido',
    columnName: 'valorPedido',
    text: 'Valor Pedido',
    hidden: true,
    numberFormat: 'currency',
  },
  {
    ordination: { ordinationName: 'ESTOQUE_PENDENTE', ordinationValue: '' },
    align: 'right',
    order: 22,
    id: 23,
    dataField: 'estoquePendente',
    columnName: 'estoquePendente',
    text: 'Dias Pend',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'ESTOQUE_PROJECAO', ordinationValue: '' },
    align: 'right',
    order: 23,
    id: 24,
    dataField: 'estoqueProjecao',
    columnName: 'estoqueProjecao',
    text: 'Dias Proj',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'ESTOQUE_FUTURO', ordinationValue: '' },
    align: 'right',
    order: 24,
    id: 25,
    dataField: 'estoqueFuturo',
    columnName: 'estoqueFuturo',
    text: 'Dias Futuro',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'PERCENTUAL_DESCONTO', ordinationValue: '' },
    align: 'center',
    order: 27,
    id: 28,
    dataField: 'percentualDesconto',
    columnName: 'percentualDesconto',
    text: '% Desc',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'ESTOQUE_ATUAL', ordinationValue: '' },
    align: 'right',
    order: 32,
    id: 33,
    dataField: 'estoqueAtual',
    columnName: 'estoqueAtual',
    text: 'Dias Estoque Atual',
    hidden: true,
  },
  {
    ordination: { ordinationName: '', ordinationValue: '' },
    align: 'center',
    order: 33,
    id: 34,
    dataField: 'demandas',
    columnName: 'demandas',
    text: 'Demandas',
    hidden: true,
  },
  {
    ordination: { ordinationName: '', ordinationValue: '' },
    align: 'center',
    order: 34,
    id: 35,
    dataField: 'alterado',
    text: 'Alterado',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: '', ordinationValue: '' },
    align: 'right',
    order: 35,
    id: 36,
    dataField: 'bloquadoCompra',
    columnName: 'bloquadoCompra',
    text: 'BloqCompra',
    hidden: true,
    fixed: true,
  },
  { align: 'center', order: 36, id: 37, dataField: 'filial', columnName: 'filial', text: 'FILIAL', hidden: false, fixed: true },
  {
    ordination: { ordinationName: 'PRECO_REPOSICAO', ordinationValue: '' },
    align: 'right',
    order: 37,
    id: 38,
    dataField: 'precoReposicao',
    columnName: 'precoReposicao',
    text: 'Preço Reposição',
    hidden: true,
    typeField: 'monetary',
    numberFormat: 'currency',
  },
  {
    align: 'right',
    order: 39,
    id: 40,
    dataField: 'percVariacao',
    columnName: 'percVariacao',
    text: 'Var % Prç Rep x Cst Méd',
    hidden: false,
    numberFormat: 'percent',
  },
  { align: 'center', order: 38, id: 39, dataField: 'observacao', text: 'Observação', hidden: false, fixed: true },
];

